/* Current. Drift Collection — gallery, scent tabs, quantity and add to bag.
   Loaded by each drift-* section; the guard stops it running twice. */
(function () {
  if (window.__drift) return;
  window.__drift = true;

  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  // Gallery: thumbnails swap the main slide
  function initGallery(root) {
    var slides = root.querySelectorAll('[data-drift-slide]');
    var thumbs = root.querySelectorAll('[data-drift-thumb]');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = t.getAttribute('data-drift-thumb');
        slides.forEach(function (s) { s.hidden = s.getAttribute('data-drift-slide') !== i; });
        thumbs.forEach(function (b) { b.setAttribute('aria-current', b === t ? 'true' : 'false'); });
      });
    });
  }

  // Ingredient viewer. Works for every layout: panels get .is-active and --o
  // (how many steps behind the active one they are), tabs/dots get aria-selected.
  function initTabs(root) {
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-drift-panel]'));
    var n = panels.length;
    if (!n) return;
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    var current = 0, timer = null, touched = false;
    var hideInactive = ['split', 'poster'].indexOf(root.getAttribute('data-layout')) > -1;
    function select(i, focus) {
      current = ((i % n) + n) % n;
      panels.forEach(function (p, k) {
        var o = (k - current + n) % n;
        p.classList.toggle('is-active', o === 0);
        p.style.setProperty('--o', o);
        if (hideInactive) p.setAttribute('aria-hidden', o === 0 ? 'false' : 'true');
      });
      tabs.forEach(function (t) {
        var on = parseInt(t.getAttribute('data-drift-index'), 10) === current;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (on && focus) t.focus();
      });
      root.setAttribute('data-current', current);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function user(i, focus) { touched = true; stop(); select(i, focus); }
    root._driftSelect = user;

    tabs.forEach(function (t) {
      var i = parseInt(t.getAttribute('data-drift-index'), 10);
      t.addEventListener('click', function () { user(i); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); user(current + 1, true); }
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); user(current - 1, true); }
      });
    });
    root.querySelectorAll('[data-drift-open]').forEach(function (b) {
      b.addEventListener('click', function () { user(parseInt(b.getAttribute('data-drift-open'), 10)); });
    });
    root.querySelectorAll('[data-drift-prev]').forEach(function (b) { b.addEventListener('click', function () { user(current - 1); }); });
    root.querySelectorAll('[data-drift-next]').forEach(function (b) { b.addEventListener('click', function () { user(current + 1); }); });

    var stage = root.querySelector('[data-drift-stage]');
    if (stage && root.getAttribute('data-layout') !== 'row') {
      var x0 = null;
      stage.addEventListener('pointerdown', function (e) { x0 = e.clientX; });
      stage.addEventListener('pointerup', function (e) {
        if (x0 === null) return;
        var dx = e.clientX - x0; x0 = null;
        if (Math.abs(dx) > 40) user(current + (dx < 0 ? 1 : -1));
      });
    }
    // Side by side on mobile scrolls: keep the highlighted card in step with the scroll
    if (stage && root.getAttribute('data-layout') === 'row' && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (en.isIntersecting && en.intersectionRatio > 0.6 && stage.scrollWidth > stage.clientWidth + 4) {
            select(panels.indexOf(en.target));
          }
        });
      }, { root: stage, threshold: [0.6] });
      panels.forEach(function (p) { io.observe(p); });
      root._driftSelect = function (i) {
        touched = true; stop(); select(i);
        if (stage.scrollWidth > stage.clientWidth + 4) stage.scrollTo({ left: panels[current].offsetLeft - stage.offsetLeft - 20, behavior: 'smooth' });
      };
    }

    var secs = parseInt(root.getAttribute('data-drift-autoplay'), 10);
    var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (secs > 0 && !calm && n > 1) {
      var start = function () { if (!timer && !touched) timer = setInterval(function () { select(current + 1); }, secs * 1000); };
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', function () { touched = true; stop(); });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) start(); else stop(); }); }, { threshold: 0.4 }).observe(root);
      } else start();
    }
    select(0);
  }

  // Quantity stepper
  function initQty(root) {
    var input = root.querySelector('input');
    root.querySelectorAll('[data-drift-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        v = Math.min(99, Math.max(1, v + parseInt(b.getAttribute('data-drift-step'), 10)));
        input.value = v;
      });
    });
  }

  // Add to bag: AJAX add, then tell Horizon the cart changed.
  // data-drift-after="cart" sends people straight to the cart page instead.
  function initAtc(form) {
    form.addEventListener('submit', function (e) {
      if (form.getAttribute('data-drift-after') === 'cart') return; // normal post to /cart/add
      if (!window.fetch || !window.FormData) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var err = form.querySelector('[data-drift-error]');
      var label = btn.textContent;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      btn.setAttribute('aria-busy', 'true');
      if (err) err.textContent = '';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.d.description || res.d.message || 'Could not add to bag');
          return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          var detail = { resource: cart, sourceId: form.id, data: { source: 'product-form-component', itemCount: cart.item_count } };
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: detail }));
          document.querySelectorAll('[data-cart-count], .cart-count, cart-count').forEach(function (el) { el.textContent = cart.item_count; });
          btn.textContent = form.getAttribute('data-drift-added') || 'Added to bag';
          setTimeout(function () { btn.textContent = label; }, 1800);
          var drawer = document.querySelector('cart-drawer-component');
          if (drawer && typeof drawer.open === 'function' && form.getAttribute('data-drift-after') === 'drawer') {
            try { drawer.open(); } catch (x) {}
          }
        })
        .catch(function (x) {
          if (err) err.textContent = x.message;
          else window.location.href = root + 'cart';
        })
        .finally(function () { btn.removeAttribute('aria-busy'); });
    });
  }

  function init(scope) {
    scope.querySelectorAll('[data-drift-gallery]:not([data-drift-ready])').forEach(function (el) { el.setAttribute('data-drift-ready', ''); initGallery(el); });
    scope.querySelectorAll('[data-drift-tabs]:not([data-drift-ready])').forEach(function (el) { el.setAttribute('data-drift-ready', ''); initTabs(el); });
    scope.querySelectorAll('[data-drift-qty]:not([data-drift-ready])').forEach(function (el) { el.setAttribute('data-drift-ready', ''); initQty(el); });
    scope.querySelectorAll('form[data-drift-atc]:not([data-drift-ready])').forEach(function (el) { el.setAttribute('data-drift-ready', ''); initAtc(el); });
  }

  // Scent chips in Product information: open that note in the scent section
  document.addEventListener('click', function (e) {
    var chip = e.target.closest && e.target.closest('[data-drift-goto]');
    if (!chip) return;
    var root = document.querySelector('[data-drift-tabs]');
    if (!root) return; // no scent section on the page: let the link behave normally
    e.preventDefault();
    var i = parseInt(chip.getAttribute('data-drift-goto'), 10);
    if (root._driftSelect) root._driftSelect(i);
    var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    root.scrollIntoView({ behavior: calm ? 'auto' : 'smooth', block: 'center' });
  });

  onReady(function () { init(document); });
  // Re-run when sections are edited in the theme editor
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
